interface Props {
  size?: number;
  className?: string;
  /** Override the gradient — defaults to a warm gold. */
  filled?: boolean;
}

/** Five-pointed gold star with a subtle gradient and outline. */
export function StarIcon({ size = 16, className, filled = true }: Props) {
  const gradId = `star-grad-${size}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-label="stars"
      role="img"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#F4C56A" />
          <stop offset="1" stopColor="#C9A05C" />
        </linearGradient>
      </defs>
      <path
        d="M12 2.5 L14.55 8.7 L21.2 9.3 L16.1 13.8 L17.65 20.4 L12 16.9 L6.35 20.4 L7.9 13.8 L2.8 9.3 L9.45 8.7 Z"
        fill={filled ? `url(#${gradId})` : 'none'}
        stroke="#9B7A40"
        strokeWidth="0.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}
